import React, { createContext, useContext, useState } from 'react';
import { cooperplaceApi } from 'services/api';
import { Text } from 'v3/components';
import { useSnackbarStacked } from 'v3/components/SnackbarStacked';
import schema from './schema';

export const InsuranceValueContext = createContext();
export const useInsuranceValue = () => useContext(InsuranceValueContext);

export function InsuranceValueContextProvider({ children }) {
  const [insuranceBenner, setInsuranceBenner] = useState(0);
  const snackbar = useSnackbarStacked();
  const [loading, setLoading] = useState(false);

  async function fetchInsuranceValue(props) {
    try {
      setLoading(true);
      const { data } = await cooperplaceApi.get('insurance-value', {
        params: props,
      });

      setLoading(false);
      return data.percentage;
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
    return null;
  }

  async function fetchInsuranceValueByLoadId(loadId) {
    setLoading(true);
    try {
      const { data } = await cooperplaceApi.get(`loads/${loadId}/insurance-value`);
      setLoading(false);
      return data.percentage;
    } catch (error) {
      snackbar.show(<Text>Error ao buscar valor do seguro</Text>, {
        type: 'error',
        duration: 5000,
      });
      console.error(error);
    }

    setLoading(false);
    return null;
  }

  async function validate(props) {
    try {
      await schema.validate(props, { abortEarly: false });
      return true;
    } catch (error) {
      return false;
    }
  }

  async function setInsuranceValue(value) {
    if (value !== undefined && value !== null && value !== insuranceBenner) {
      snackbar.show(
        <Text>Seguro Coopercarga alterado para R$ {value.toLocaleString('pt-BR')}</Text>,
        { type: 'warning', duration: 5000 },
      );
      setInsuranceBenner(value);
      return value;
    }

    return insuranceBenner;
  }

  async function updateInsuranceValue(props) {
    const updatedFilters = {
      ...props,
    };

    updatedFilters.type =
      updatedFilters.originCountry === 'br' && updatedFilters.destinationCountry === 'br'
        ? 'NATIONAL'
        : 'INTERNATIONAL';

    if (await validate(updatedFilters)) {
      const value = await fetchInsuranceValue(updatedFilters);
      return setInsuranceValue(value);
    }

    return insuranceBenner;
  }

  async function updateInsuranceValueByLoadId(loadId) {
    const value = await fetchInsuranceValueByLoadId(loadId);
    return setInsuranceValue(value);
  }

  return (
    <InsuranceValueContext.Provider
      value={{
        updateInsuranceValue,
        updateInsuranceValueByLoadId,
        insuranceBenner,
        loading,
      }}
    >
      {children}
    </InsuranceValueContext.Provider>
  );
}
